"use client"

import * as React from "react"

import { cn } from "../../lib/utils"
import { DatePicker, type DatePickerProps } from "./date-picker"
import { Input } from "./input"

export interface TimePickerProps extends React.HTMLAttributes<HTMLDivElement> {
  datePickerProps?: DatePickerProps
  time?: string
  onTimeChange?: (time: string) => void
  inputProps?: Omit<
    React.ComponentProps<typeof Input>,
    "type" | "value" | "onChange"
  >
}

export function TimePicker({
  datePickerProps,
  time,
  onTimeChange,
  inputProps,
  className,
  ...props
}: TimePickerProps) {
  const timeValueProps =
    time === undefined ? {} : ({ value: time } as const)

  return (
    <div className={cn("flex items-center gap-2", className)} {...props}>
      <DatePicker {...datePickerProps} className={cn("min-w-32", datePickerProps?.className)} />
      <Input
        {...inputProps}
        {...timeValueProps}
        className={cn("w-auto", inputProps?.className)}
        type="time"
        onChange={(e) => onTimeChange?.(e.target.value)}
      />
    </div>
  )
}
